(() => {
  const newsletter = document.querySelector('[data-ovd-newsletter]');
  const newsletterClose = document.querySelector('[data-ovd-newsletter-close]');
  const newsletterSuccess = document.querySelector('[data-ovd-newsletter-success]');
  const newsletterError = document.querySelector('[data-ovd-newsletter-error]');
  const dismissalKey = 'ovdNewsletterDismissedAt';
  const subscribedKey = 'ovdNewsletterSubscribed';
  const dismissalWindow = 14 * 24 * 60 * 60 * 1000;
  let newsletterTimer;

  if (!newsletter) return;

  const storageGet = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const storageSet = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in private browsing.
    }
  };

  const hideNewsletter = (remember = true) => {
    newsletter.hidden = true;
    if (remember) storageSet(dismissalKey, String(Date.now()));
  };

  const newsletterIsSuppressed = () => {
    if (storageGet(subscribedKey) === 'true') return true;
    const dismissedAt = Number(storageGet(dismissalKey) || 0);
    return dismissedAt > 0 && Date.now() - dismissedAt < dismissalWindow;
  };

  const showNewsletter = () => {
    if (newsletterIsSuppressed()) return;
    newsletter.hidden = false;
    newsletter.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    window.removeEventListener('scroll', handleScroll);
    window.clearTimeout(newsletterTimer);
  };

  const handleScroll = () => {
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (documentHeight > 0 && window.scrollY / documentHeight >= 0.60) showNewsletter();
  };

  const scheduleNewsletter = () => {
    if (newsletterSuccess || newsletterError || newsletterIsSuppressed()) return;
    window.clearTimeout(newsletterTimer);
    newsletterTimer = window.setTimeout(showNewsletter, 22000);
    window.addEventListener('scroll', handleScroll, { passive: true });
  };

  newsletterClose?.addEventListener('click', () => hideNewsletter(true));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !newsletter.hidden) hideNewsletter(true);
  });

  if (newsletterSuccess) {
    storageSet(subscribedKey, 'true');
    newsletter.hidden = false;
  } else if (newsletterError) {
    newsletter.hidden = false;
  } else {
    scheduleNewsletter();
  }
})();
